"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = _interopRequireDefault(require("../index"));
var version = "v1";
var _default = exports["default"] = {
  create: function create(attributes) {
    var payload = {
      data: {
        type: "transportation",
        attributes: attributes
      }
    };
    return _index["default"].post("/".concat(version, "/requests/transportation"), payload);
  }
};